import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "showUploadProgress", "size", "uploadProgress"];
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import React from 'react';
import { useTranslation } from 'react-i18next';
var FileSizeField = function FileSizeField(_ref) {
  var id = _ref.id,
    showUploadProgress = _ref.showUploadProgress,
    size = _ref.size,
    uploadProgress = _ref.uploadProgress,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var progress = " (".concat(t('form_uploaded_progress', {
    progress: "".concat(Math.ceil(uploadProgress !== null && uploadProgress !== void 0 ? uploadProgress : 0), "%")
  }), ")");
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('form_file_size_colon'),
    labelId: uniqueId
  }, otherProps), size, showUploadProgress && progress);
};
export default FileSizeField;